module.exports = __webpack_public_path__ + "static/media/contact_phone.9e6bc7c7.jpg";